export enum RoleSelectionType {
  Single,
  Multiple,
}
